import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { timer, Subscription } from 'rxjs';
import { takeWhile, tap } from 'rxjs/operators';

@Component({
    selector: 'app-idle-warning-dialog',
    template: `
    <h2 mat-dialog-title>Session About to Expire</h2>
    <mat-dialog-content>
      <div class="warning-content">
        <mat-icon class="warning-icon">warning</mat-icon>
        <p>You will be automatically logged out in <strong>{{ countdown }}</strong> seconds due to inactivity.</p>
        <p>Click "Continue" to extend your session.</p>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="extendSession()">Continue</button>
      <button mat-button color="warn" (click)="logoutNow()">Logout Now</button>
    </mat-dialog-actions>
  `,
    styles: [`
    .warning-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding: 20px 0;
    }
    .warning-icon {
      font-size: 48px;
      height: 48px;
      width: 48px;
      color: #ff9800;
      margin-bottom: 16px;
    }
    p {
      margin: 8px 0;
      font-size: 14px;
    }
    strong {
      color: #f44336;
      font-size: 16px;
    }
  `]
})
export class IdleWarningDialogComponent implements OnDestroy {
    countdown = 60; // 1 minute countdown
    private isActive = true;
    private countdownSubscription?: Subscription;

    constructor(
        public dialogRef: MatDialogRef<IdleWarningDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.startCountdown();
    }

    private startCountdown() {
        this.countdownSubscription = timer(0, 1000)
            .pipe(
                takeWhile(() => this.isActive && this.countdown > 0),
                tap(() => {
                    this.countdown--;
                    if (this.countdown === 0) {
                        this.dialogRef.close('timeout');
                    }
                })
            )
            .subscribe();
    }

    extendSession() {
        this.isActive = false;
        this.dialogRef.close('extend');
    }

    logoutNow() {
        this.isActive = false;
        this.dialogRef.close('logout');
    }

    ngOnDestroy() {
        this.isActive = false;
        if (this.countdownSubscription) {
            this.countdownSubscription.unsubscribe();
        }
    }
}
